import script from "./SterrenActieJohannesDeDoperMapKikirpa.vue?vue&type=script&setup=true&lang=js"
export * from "./SterrenActieJohannesDeDoperMapKikirpa.vue?vue&type=script&setup=true&lang=js"

import "./SterrenActieJohannesDeDoperMapKikirpa.vue?vue&type=style&index=0&id=2839af5e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2839af5e"]])

export default __exports__